import { Divider } from '@cast/design-system';
import { Node } from '@cast/types';

import { Detail } from 'components/drawer';
import {
  makeNodeConfigTemplatesLink,
  makeSelectionTemplatesLink,
} from 'features/cluster/autoscaler/utils';

import { TemplateLinkWithVersion } from '../_components/TemplateLinkWithVersion';
import {
  getNodeConfigurationName,
  getNodeConfigurationVersion,
  getNodeSelectionTemplateName,
  getNodeSelectionTemplateVersion,
} from '../_utils/common';

type Props = {
  node?: Node;
  clusterId: string;
  showDivider?: boolean;
  withVersionPrefix?: boolean;
};

export const NodeTemplatesSection = ({
  node,
  clusterId,
  showDivider = true,
  withVersionPrefix,
}: Props) => {
  let configurationTemplateName: string | undefined;
  let configurationTemplateVersion: string | undefined;
  let selectionTemplateName: string | undefined;
  let selectionTemplateVersion: string | undefined;

  if (node) {
    configurationTemplateName = getNodeConfigurationName(node);
    configurationTemplateVersion = getNodeConfigurationVersion(node);
    selectionTemplateName = getNodeSelectionTemplateName(node);
    selectionTemplateVersion = getNodeSelectionTemplateVersion(node);
  }

  const showConfigurationTemplate =
    typeof configurationTemplateName !== 'undefined' &&
    typeof configurationTemplateVersion !== 'undefined';
  const showSelectionTemplate =
    typeof selectionTemplateName !== 'undefined' &&
    typeof selectionTemplateVersion !== 'undefined';

  if (!(showConfigurationTemplate || showSelectionTemplate)) {
    return null;
  }

  return (
    <>
      <div>
        {showSelectionTemplate && (
          <Detail
            title="Node template:"
            testId="node-details-node-template"
            detail={
              <TemplateLinkWithVersion
                testId="node-templates-link"
                name={selectionTemplateName!}
                version={selectionTemplateVersion!}
                path={makeSelectionTemplatesLink({
                  clusterId,
                  openTemplate: selectionTemplateName,
                })}
                withVersionPrefix={withVersionPrefix}
              />
            }
          />
        )}

        {showConfigurationTemplate && (
          <Detail
            title="configuration:"
            testId="node-details-node-configuration"
            detail={
              <TemplateLinkWithVersion
                testId="node-configuration-link"
                name={configurationTemplateName!}
                version={configurationTemplateVersion!}
                path={makeNodeConfigTemplatesLink({
                  clusterId,
                  search: {
                    openConfig: configurationTemplateName,
                  },
                })}
                withVersionPrefix={withVersionPrefix}
              />
            }
          />
        )}
      </div>

      {showDivider && <Divider />}
    </>
  );
};
